export const enum MyAccountToggleSaveButtonListingContextEnum {
  /**
   * Default listing context
   */
  default = 'default',

  /**
   * Map search context
   */
  mapSearch = 'mapSearch',
}
